import React, {Component} from 'react';
import './styles.scss';
import Asset from 'src/requests/apa/Asset';

class CardVoid extends Component {
  constructor(props) {
    super();
    this.placeholder = Asset.get(`ribbons_placeholder_${props.placeholder}_background`, "") || Asset.get(`ribbons_placeholder_generic_background`, "")
  }

  render() {
    return (
      <div className={'card card-void'}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            <div className="card-placeholder"
              style={{ backgroundImage: `url(${this.placeholder})` }}
            alt="placeholder"/>
          </div>
        </div>
      </div>
    );
  }
}

export default CardVoid;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardVoid/index.js